import { Repository } from "src/firebase/firestore/repository";
import { UserNotificationsTokens } from "../types/fcm.entity";

export class FcmTokenRepository extends Repository<UserNotificationsTokens> {
  constructor() {
    super("users_notifications_tokens");
  }
}

export const fcmTokenRepository = new FcmTokenRepository();
